module.exports = __webpack_public_path__ + "img/01.e7f3b8df.png";